module.exports = __webpack_public_path__ + "img/刘斌.c8fec0a0.jpg";